export const environment = {
  production: true,
  debugMode: true,
  ENVIRONMENT: 'dev',
  registerServiceWorker: true,
  sentryDSN: 'https://a40e8719561d497aa04f7fbec1489d21@errcol.g.placewise.com/4',
  sentryEnvironment: 'dev',
  commitId: 'b366f75ec12a1a97c42182af1fc7c22164f601da',
  webforms_api: '/api',
  passwordMinLength: 8,
  dmpEvents: true,
  recaptchaBaseKey: '6LcVLSwdAAAAAFdAdLYMetuwSOz_qnQZ8_wTJGM_',
  recaptchaCheckboxKey: '6LfGyzcdAAAAAOSE24RnK9P4bzGjyEadx3RLJ6Bd',
  authApi: '/v1',
  mobileEventsDebugEnabled: false,
};
